import { useState, useEffect } from 'react';
import './Login.scss';
import '../../../assets/Geogrotesque/geofrotesque.css';
import environment from '../../../environment';
import { NavLink, useLocation } from 'react-router-dom';
import Topo from '../../../components/EmpresaConvenio';
import BannerEmpresaConvenio from '../../../components/EmpresaConvenio/BannerEmpresaConvenio';
import '../../../components/EmpresaConvenio/EmpresaConvenio.css';
import AuthRUService from '../../../services/Auth';

const LoginLDAP = () => {
    const [politica, setPolitica] = useState(false);
    const location = useLocation();

    useEffect(() => {
        let _politica = localStorage.getItem("uninterPolitica_" + environment.ambiente);
        setPolitica(_politica === "true");
    }, []);

    const _handlePolitica = () => {
        setPolitica(true);
        localStorage.setItem("uninterPolitica_" + environment.ambiente, true);
    }

    const handleLoginClick = () => {
        AuthRUService.iniciarLoginUnificado();
    };

    // Lógica de Título (Oculta ambiente em Produção)
    const isProducao = !environment.ambiente ||
        environment.ambiente.toLowerCase() === 'prod' ||
        environment.ambiente.toLowerCase() === 'production';

    const tituloExibicao = isProducao
        ? "EMPRESA CADASTRADA"
        : `EMPRESA CADASTRADA - ${environment.ambiente.toUpperCase()}`;

    // Detecta se já está voltando do login para mostrar o loading
    const isSyncing = new URLSearchParams(location.search).has("login_session");

    return (
        <>
            <div>
                <Topo />
                <BannerEmpresaConvenio />
                <div className="uninter-container-convenioempresas">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 offset-lg-1 uninter-topo-convenioempresas">
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                            <h3>CONVÊNIO EMPRESARIAL UNINTER</h3>
                            <br />
                            <div className="uninter-conteudo-texto-convenioempresas">
                                <p>Quem quer superar metas e desafios — e reconhece o conhecimento como o caminho mais seguro para o sucesso — tem tudo a ver com a Uninter.</p>
                                <p>Estamos entre os maiores grupos educacionais do país, com polos presenciais em mais de 800 polos ao redor do país, nos EUA, em Portugal, na Espanha, no Japão, no Reino Unido ou na Itália, por meio de notebook, tablet ou celular. Além de nos conferir um excelente conceito geral no MEC, a nossa qualidade de ensino nos tornou uma referência não só para o mercado, mas também para as pessoas que acompanham a evolução e as conquistas de nossos alunos.</p>
                                <p>Com o Convênio Empresarial Uninter, sua empresa tem a oportunidade de fazer parte da missão de transformar vidas por meio da educação. Seja no modelo de convênio desconto ou de contrato pagamento, essa é a iniciativa ideal para estimular o contínuo desenvolvimento dos colaboradores, bem como de seus dependentes e familiares. E sem custo para a empresa!</p>
                                <p>A Uninter já é parceira de mais de 19.000 organizações, como: fundações, prefeituras, sindicatos, associações e outras empresas. Faça parte disso: ofereça esse benefício e aproveite as vantagens.</p>
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                            <div className="uninter-box-home-convenioempresas">
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 uninter-box-home-un1">
                                    <div className="uninter-box-home-convenioempresas-un1">
                                        <h3>CADASTRO DE EMPRESA</h3>
                                        <span>Preencha o Formulário clicando no botão abaixo.</span>
                                        <NavLink to={politica ? "/formulario" : "/login"}>
                                            <div className="chamaFormulario uninter-box-home-convenioempresas-btn">
                                                Formulário para<br /> Formalização de Convênio
                                            </div>
                                        </NavLink>
                                    </div>
                                </div>
                                {/* BOX Área Privada (Login Unificado) */}
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 uninter-box-home-un2">
                                    <div className="uninter-box-home-convenioempresas-un2" style={{ minHeight: '80px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <h3>{tituloExibicao}</h3>

                                        {isSyncing ? (
                                            <div className="text-center py-3">
                                                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#f37021' }}></i>
                                                <p className="mt-2">Sincronizando...</p>
                                            </div>
                                        ) : (
                                            <>
                                                <span>Acesse sua <b>Área Privada</b> com segurança.</span>
                                                <button
                                                    className="uninter-box-home-convenioempresas-btn"
                                                    onClick={handleLoginClick}
                                                    style={{ width: '100%', marginTop: '15px' }}
                                                >
                                                    ACESSAR ÁREA PRIVADA
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                            <div className="uninter-conteudo-texto-convenioempresas-box-paragrafos col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <br />
                                    <h3>CONVÊNIO DESCONTO</h3>
                                    <br />
                                    <div className="uninter-conteudo-texto-convenioempresas">
                                        <p>Neste formato de parceria, a Uninter concede aos beneficiários* o <b>DESCONTO DE 10%</b> sobre o valor líquido das mensalidades dos cursos de graduação e de pós-graduação (Lato Sensu), nos formatos a distância, presencial e semipresencial. Válido também para o EJA (Educação de Jovens e Adultos), na modalidade a distância.</p>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <br />
                                    <h3>CONTRATO PAGAMENTO (CONVÊNIO)</h3>
                                    <br />
                                    <div className="uninter-conteudo-texto-convenioempresas">
                                        <p>No convênio por contrato pagamento, <b>a empresa pode custear o percentual de até 100%</b> do valor das parcelas mensais do curso de seus colaboradores. Caso o percentual deste investimento da empresa não atenda a totalidade dos custos, o colaborador terá a responsabilidade de arcar com o saldo restante das parcelas/mensalidades, dentro do prazo de vencimento estipulado em contrato. Por meio deste formato de parceria, todas as modalidades e níveis de cursos também estão disponíveis. Caso tenha interesse neste tipo de contrato, favor encaminhar e-mail para <a href="mailto:parceria.corporativo@uninter.com" style={{ color: '#f37021', fontWeight: 'bold' }}>parceria.corporativo@uninter.com</a>.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!politica && (
                <div className="uninter-conteudo-barra-texto-politicaprivacidade" id="cookie-law-info-bar">
                    <div className="cli-bar-container cli-style-v2">
                        <div className="cli-bar-message">Nós usamos cookies para melhorar a sua experiência... <a href="https://www.uninter.com/politica-de-privacidade/"> Política de Privacidade</a>.</div>
                        <div className="cli-bar-btn_container">
                            <a role="button" onClick={_handlePolitica} className="large cli-plugin-button">Concordo</a>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default LoginLDAP;